module.exports = __webpack_public_path__ + "img/introduce_en.17a35ed7.png";